<template>
	<v-container class="pt-0">
		<div>
			<v-row>
				<v-col cols="12" lg="12" md="12">
					<s-crud
						:config="configAssistence"
						:filter="filterAssistence"
						search-input
						title="Lista de Personal"
						ref="scrudAssistenceList"
						height="auto"
						:disabled="false"
						no-full
					>
						<template v-slot:filter>
							<v-col>
								<v-card>
									<v-row justify="center">
                                        <v-col cols="12" md="4" sm="12">
                                            <s-select-definition
                                                label="Nave"
                                                :def="1342"
                                                v-model="filterAssistence.TypeShip"
                                                clearable
                                            ></s-select-definition>
                                        </v-col>

                                        <v-col cols="12" md="4" sm="12">
                                            <s-select-definition
                                                label="Turno"
                                                :def="1278"
                                                v-model="filterAssistence.TrnID"
                                                clearable
                                            ></s-select-definition>
                                        </v-col>

                                        <v-col cols="12" md="4" sm="12">
                                            <s-select-definition
                                                label="Area"
                                                v-model="filterAssistence.AreID"
                                                :def="def"
                                                :dgr="dgr"
                                                clearable
                                            ></s-select-definition>
                                        </v-col>
									</v-row>
								</v-card>
							</v-col>
						</template>
					</s-crud>
				</v-col>
			</v-row>
		</div>
	</v-container>
</template>
<script>
	//Service
	import _sTurnWorKerervice from "../../../services/FreshProduction/PrfAssignTurnWorKerDetailServiceList";
	import sSelectActivityArea from "../../../components/FreshProduction/Turn/sSelectActivityArea.vue";

	export default {
		components: { sSelectActivityArea },

		data: () => ({
			filterAssistence: { 
                TypeShip: null,
                TrnID: null,
                AreID: null
             },
			configAssistence: {
				model: {
					AgdID: "ID",
					AgdBeginDate: "datetime",
					AgdEndDate: "datetime",
				},
				service: _sTurnWorKerervice,
				headers: [
					{ text: "Persona", value: "NtpNameFull", sortable: false },
					{ text: "Nave", value: "TypeShipName", sortable: false },
					{ text: "Turno", value: "TypeTurnName", sortable: false },
					{ text: "Area", value: "TypeAreName", sortable: false },
					{ text: "Actividad", value: "AtaName", sortable: false },
					{ text: "Inicio", value: "AgdBeginDate", sortable: false },
					{ text: "Fin", value: "AgdEndDate", sortable: false },
					{ text: "Estado", value: "AtaName", sortable: false },
				],
			},
			dgr: 40,
			def: 1281,
		}),
	};
</script>